import { Fragment } from 'react';
import cc from 'classcat';

import CountdownComponent from './CountdownComponent';
import styles from './styles.module.scss';
import { useCountdown } from './use-countdown';

const UNITS = ['minutes', 'secs'].map((unit) => {
  return {
    singular: unit.replace(/s$/, ''),
    key: unit === 'secs' ? 'seconds' : unit,
  };
});

const defaultStrings = {
  heading: `Your personalized plan has been reserved for the next 15 minutes!`,
  cta: 'Save your profile below to claim it now.',
  label: 'Time remaining: ',
};

export const Countdown = ({ strings, toDate, onZero }) => {
  const values = useCountdown(toDate, onZero);
  const str = { ...defaultStrings, ...strings };
  if (!values) return <Fragment />;
  return (
    <div className={styles.container}>
      <div className={styles.timerWrapper}>
        <div className={styles.countdownTitle}>{str.heading}</div>
        <div className={styles.countdownInfo}>{str.cta}</div>
        <div className={cc([styles.countdownTitle, styles.countdownTimer])}>
          <div className={styles.label}>{str.label}</div>
          <div className={styles.time}>
            {UNITS.map((unit) => {
              const value =
                unit.key === 'minutes'
                  ? values[unit.key] + ':'
                  : values[unit.key];
              return (
                <CountdownComponent
                  key={`countdown-${unit.key}`}
                  value={value}
                />
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};
